/**
 * Class description
 *
 * Created: 2018-05-22
 * @author jonas
 */
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Timeline, TimelineLite} from "gsap";
import {StateMatrix} from "../../utils/StateMatrix";
import {IAdjacentBetLineWinData, SymbolUtil} from "../../utils/SymbolUtil";
import {DirtyWildsBetLinesEvent} from "../betlines/DirtyWildsBetLines";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {DirtyWildsGameConfig} from "../DirtyWildsGameConfig";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";
import {DirtyWildGameMode} from "../features/DirtyWildsRespinZeroBetController";
import {DirtyWildsParsedGameData} from "../server/data/DirtyWildsParsedGameData";
import {DirtyWildsStateReelSymbol} from "../symbols/DirtyWildsStateReelSymbol";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {DirtyWildsLayerConfig} from "../../config/DirtyWildsLayerConfig";
import {DirtyWilds} from "../DirtyWilds";

export class DirtyWildsInitialWPController extends WinPresentationController {
    private _symbolStates: StateMatrix<string>;
    private _winSymbols: StateReelSymbol[][];
    private _noWinSymbols: DirtyWildsStateReelSymbol[];
    private _masterTimeLine: TimelineLite | null;
    private _isBigWin: boolean;
    private _dirtyWildsIndexes: number[];
    private _finishTriggered: boolean;

    constructor(indexes: [number, number]) {
        super(indexes, {name: "DirtyWildsInitialWPController", skippable: true});
        this._dirtyWildsIndexes = indexes;
        this._finishTriggered = false;
    }

    protected addFeatureEventHandlers(): void {
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event: GameEvent) => this.onGameReady());
    }

    protected hasWin(): boolean {
        return this._betWinsData != null && this._betWinsData.length > 0;
    }

    protected parseFeatureGameData(data: DirtyWildsParsedGameData): void {
        this._isBigWin = data.isMultipliedBigWin;

        // #231
        DirtyWildsGameConfig.instance.WIN_BELOW_STAKE = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.totalSpinWinningsMultiplied <= data.playedBetValue));
    }

    protected resetFeature(): void {
        // DirtyWildGameModuleConfig.environment.getHideNoWinColor(0.5);
        // DirtyWildGameModuleConfig.effectManager.getWinDarkening(1.0, true);
    }

    protected startWinPresentation(): void {
        this._finishTriggered = false;
        const gameData: DirtyWildsParsedGameData = <DirtyWildsParsedGameData>this._gameData!;
        const indiSymWinAmountCont: PIXI.Container[] = this.getUniqueWinSymHighlight(gameData);
        const winSymbolsFromLeft: StateMatrix<string> = SymbolUtil.createSymbolStateMatrixFromBetWinsFromDirection(<IBetLineWinData[]>this._betWinsData!, "Left");
        const winSymbolsFromRight: StateMatrix<string> = SymbolUtil.createSymbolStateMatrixFromBetWinsFromDirection(<IBetLineWinData[]>this._betWinsData!, "Right");

        this._symbolStates = SymbolUtil.createSymbolStateMatrixFromBetWins(<IBetLineWinData[]>this._betWinsData!);
        this._winSymbols = SymbolUtil.getSymbolsWithStatePerReel(this._symbolStates, DirtyWildsGameConfig.instance.SYMBOL_STATES.win.keyword);
        this._noWinSymbols = SymbolUtil.getSymbolsWithState(this._symbolStates, DirtyWildsGameConfig.instance.SYMBOL_STATES.noWin.keyword);


        let tl: TimelineLite = new TimelineLite();
        let noWinSymbolsAnimation: Timeline[] = SymbolUtil.getDirtySymbolStateAnimations(this._noWinSymbols, DirtyWildsGameConfig.instance.SYMBOL_STATES.noWin, 0.0);
        // tl.add(() => this.showBetLines());

        const winSymbolsLeft = SymbolUtil.getSymbolsWithStatePerReelForInitialWin(winSymbolsFromLeft, DirtyWildsGameConfig.instance.SYMBOL_STATES.win.keyword);
        const winSymbolsRight = SymbolUtil.getSymbolsWithStatePerReelForInitialWin(winSymbolsFromRight, DirtyWildsGameConfig.instance.SYMBOL_STATES.win.keyword);
        winSymbolsRight.reverse();

        const winBothWays: boolean = (winSymbolsLeft.filter((a) => {
            return a.length
        }).length > 0 && winSymbolsRight.filter((a) => {
            return a.length
        }).length > 0);

        const fromLeftTl: TimelineLite = new TimelineLite();
        fromLeftTl.add(() => EventHandler.dispatchEvent(new GameEvent(DirtyWildsBetLinesEvent.SHOW_INITIAL_BETLINE, "Left", <IBetLineWinData[]>this._betWinsData!)));

        if(DirtyWilds.api.gameClientConfiguration.displayIndividualWinsInGame){
            for (let i: number = 0; i < indiSymWinAmountCont.length; i++) {
                if (indiSymWinAmountCont[i].name === "leftDirectionCont") {
                    const durr: number = 0.7;
                    fromLeftTl.add(() => {
                        indiSymWinAmountCont[i].visible = true;
                    }, 0);
                    fromLeftTl.to(indiSymWinAmountCont[i], durr, {y: 300}, 0).add(() => {
                        StageManager.getLayer(DirtyWildsLayerConfig.INDIVIDUAL_SYM_WIN_AMOUNT.name).removeChild(indiSymWinAmountCont[i]);
                    });
                }
            }
        }

        for (let i: number = 0; i < winSymbolsLeft.length; i++) {
            let reelWinAnimations: Timeline[] = SymbolUtil.getSymbolStateAnimationsForInitialWin(winSymbolsLeft[i], DirtyWildsGameConfig.instance.SYMBOL_STATES.win, 0.0, winBothWays);
            let symbolsInReel = new TimelineLite();
            symbolsInReel.add(reelWinAnimations, 0, "start", 0.0);
            fromLeftTl.add(symbolsInReel, 0.1 * i);
        }


        const fromRightTl: TimelineLite = new TimelineLite();
        fromRightTl.add(() => EventHandler.dispatchEvent(new GameEvent(DirtyWildsBetLinesEvent.SHOW_INITIAL_BETLINE, "Right", <IBetLineWinData[]>this._betWinsData!)));

        if(DirtyWilds.api.gameClientConfiguration.displayIndividualWinsInGame){
            for (let i: number = 0; i < indiSymWinAmountCont.length; i++) {
                if (indiSymWinAmountCont[i].name === "rightDirectionCont") {
                    const durr: number = 0.7;
                    fromRightTl.add(() => {
                        indiSymWinAmountCont[i].visible = true;
                    });
                    fromRightTl.to(indiSymWinAmountCont[i], durr, {y: 300}, 0).add(() => {
                        StageManager.getLayer(DirtyWildsLayerConfig.INDIVIDUAL_SYM_WIN_AMOUNT.name).removeChild(indiSymWinAmountCont[i]);
                    });
                }
            }
        }

        for (let i: number = 0; i < winSymbolsRight.length; i++) {
            let reelWinAnimations: Timeline[] = SymbolUtil.getSymbolStateAnimationsForInitialWin(winSymbolsRight[i], DirtyWildsGameConfig.instance.SYMBOL_STATES.win, 0.0, winBothWays);
            let symbolsInReel = new TimelineLite();
            symbolsInReel.add(reelWinAnimations, 0, "start", 0.0);
            fromRightTl.add(symbolsInReel, 0.1 * i);
        }

        tl.add([() => {
            if (this._isBigWin) {
                SlotGame.sound.fadeAmbience(0, 2000);
            }
        },
            fromLeftTl,
            () => DirtyWildGameModuleConfig.soundPlayer.playNormalWinSound(gameData.currentMultipliedWinRatioConfig!)]);
        tl.add([
            () => {
                // #231
                if (!DirtyWildsGameConfig.instance.WIN_BELOW_STAKE) {
                    SlotGame.sound.playEffect(DirtyWildsSoundConfig.WIN_BETLINE_HIGHLIGHT);
                }
            },
            fromRightTl
        ], tl.totalDuration() - 0.35);


        //Handles both normal and big win.
        tl.add(DirtyWildGameModuleConfig.winCountUpPresentation.getCountUp(tl.totalDuration(), gameData), tl.totalDuration() - 0.7);
        tl.add(() => SlotGame.winFieldController.showWinField(this._gameData!.totalWin), tl.totalDuration() - 0.1);

        const noWinTl: TimelineLite = new TimelineLite();
        noWinTl.add(noWinSymbolsAnimation, 0);
        noWinTl.add([
            DirtyWildGameModuleConfig.environment.getShowNoWinColor(0.4),
            DirtyWildGameModuleConfig.environment.getInitialWinTransition(this._isBigWin || this._gameData!.mode === DirtyWildGameMode.RESPIN || (this._gameData!.mode === DirtyWildGameMode.NORMAL && this._gameData!.nextMode === DirtyWildGameMode.RESPIN), "enterWinDarkening"),
            // DirtyWildGameModuleConfig.effectManager.getWinDarkening(0.4, false, this._isBigWin)
        ]);
        tl.add(noWinTl, 0);
        tl.add(() => this.finish(), tl.totalDuration() + 0.1);
        this._masterTimeLine = tl;
    }

    // isAborted is for this win presentation's internal abort.
    protected finish(isAborted: boolean = false): void {
        Logger.logDev(`[WinPresentation]-${this.moduleName}.finish()`);
        this._isPlaying = false;
        this.stopWinPresentation(isAborted);
        if (!(this._gameData!.mode === DirtyWildGameMode.STICKY_RESPIN && this._gameData!.nextMode === GameMode.NORMAL)) {
            this._finishTriggered = true;
            EventHandler.dispatchEvent(new GameEvent(WinPresentationEvent.WIN_PRESENTATION_COMPLETED, this._dirtyWildsIndexes, true));
        }
    }

    protected stopWinPresentation(isAborted: boolean): void {
        //Stuff that happens after complete dispatch
        StageManager.getLayer(DirtyWildsLayerConfig.INDIVIDUAL_SYM_WIN_AMOUNT.name).removeChildren();
        let gameData = <DirtyWildsParsedGameData>this._gameData!;
        if (this._masterTimeLine) {
            if (isAborted) {
                let isActive = this._masterTimeLine.isActive();
                if (isActive) {
                    this._masterTimeLine.seek(this._masterTimeLine.totalDuration(), true);
                    this._masterTimeLine.pause();
                    this._masterTimeLine.kill();
                }
            }
            this._masterTimeLine = null;
        }
        let tl: TimelineLite = new TimelineLite({
            onComplete: () => {

            }
        });
        tl.add(DirtyWildGameModuleConfig.winCountUpPresentation.getEndAnimation(<DirtyWildsParsedGameData>this._gameData!));
        tl.add(() => {
            if ((this._gameData !== null && this._gameData!.mode === DirtyWildGameMode.STICKY_RESPIN && this._gameData!.nextMode === GameMode.NORMAL && !this._finishTriggered)) {
                this._finishTriggered = true;
                EventHandler.dispatchEvent(new GameEvent(WinPresentationEvent.WIN_PRESENTATION_COMPLETED, this._dirtyWildsIndexes, true));
            }
        }, (isAborted && this._isBigWin) ? tl.totalDuration() - 1.5 : tl.totalDuration());
        DirtyWildGameModuleConfig.environment.getHideNoWinColor(0.5);
        // DirtyWildGameModuleConfig.effectManager.getWinDarkening(1.0, true);
        DirtyWildGameModuleConfig.environment.getInitialWinTransition(this._isBigWin || this._gameData!.mode === DirtyWildGameMode.RESPIN || (this._gameData!.mode === DirtyWildGameMode.NORMAL && this._gameData!.nextMode === DirtyWildGameMode.RESPIN), "exitWinDarkening");
        SlotGame.winFieldController.showWinField();

        this._winSymbols = [];
        this._noWinSymbols = [];
    }

    // Only for playing win presentation through without abort.

    private onGameReady() {
        DirtyWildGameModuleConfig.winCountUpPresentation.abortFunction = () => this.abort();
    }

    private getDataAccordingToDirection(gameData: DirtyWildsParsedGameData) {
        const fromLeftDirectData = [],
            fromRightDirectData = [],
            fromLeftDirection: string = "Left";
        for (let i: number = 0; i < gameData.betWins.length; i++) {
            (gameData.betWins[i] as IAdjacentBetLineWinData).lineStart === fromLeftDirection ? fromLeftDirectData.push(gameData.betWins[i]) : fromRightDirectData.push(gameData.betWins[i]);
        }
        return {
            fromLeftDirection: fromLeftDirectData,
            fromRightDirection: fromRightDirectData
        }
    }

    private getUniqueWinSymHighlight(gameData: DirtyWildsParsedGameData): PIXI.Container[] {
        const dataAccordingToDirection = this.getDataAccordingToDirection(gameData),
            returnContainers: PIXI.Container[] = [];
        if (gameData.betWins.length > 0) {
            if (dataAccordingToDirection.fromLeftDirection.length > 0) {
                const leftDirectionCont: PIXI.Container = new PIXI.Container();
                leftDirectionCont.visible = false;
                leftDirectionCont.name = "leftDirectionCont";
                for (let i: number = 0; i < dataAccordingToDirection.fromLeftDirection.length; i++) {
                    const individualBetLineData: any = dataAccordingToDirection.fromLeftDirection[i];
                    createWinAmountText(individualBetLineData.multipliedAmount.toFixed(2), i, leftDirectionCont);
                }
                leftDirectionCont.pivot.set(leftDirectionCont.width / 2, leftDirectionCont.height / 2);
                leftDirectionCont.position.set(380, 360);
                returnContainers.push(leftDirectionCont);
                StageManager.getLayer(DirtyWildsLayerConfig.INDIVIDUAL_SYM_WIN_AMOUNT.name).addChild(leftDirectionCont);

            }
            if (dataAccordingToDirection.fromLeftDirection.length > 0) {
                const rightDirectionCont: PIXI.Container = new PIXI.Container();
                rightDirectionCont.visible = false;
                rightDirectionCont.name = "rightDirectionCont";
                for (let i: number = 0; i < dataAccordingToDirection.fromRightDirection.length; i++) {
                    const individualBetLineData: any = dataAccordingToDirection.fromRightDirection[i];
                    createWinAmountText(individualBetLineData.multipliedAmount.toFixed(2), i, rightDirectionCont);
                }
                rightDirectionCont.pivot.set(rightDirectionCont.width / 2, rightDirectionCont.height / 2);
                rightDirectionCont.position.set(380, 360);
                returnContainers.push(rightDirectionCont);
                StageManager.getLayer(DirtyWildsLayerConfig.INDIVIDUAL_SYM_WIN_AMOUNT.name).addChild(rightDirectionCont);

            }
        }

        function createWinAmountText(amount: string, i: number, containerToBeAddedIn: PIXI.Container): PIXI.Text {
            const winAmount: PIXI.Text = new PIXI.Text(amount, new PIXI.TextStyle({
                fontFamily: OpenSans.FAMILY,
                fontSize: 30,
                fontWeight: FontWeight.BOLD,
                fill: "#000000"
            }));
            winAmount.y = (i * 35);
            winAmount.anchor.set(0.5);
            containerToBeAddedIn.addChild(winAmount);
            return winAmount;
        }

        return returnContainers;
    }

    private showBetLines() {
        if (this._gameData) {
            for (let betLineWin of this._gameData.betWins) {
                EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, (<IBetLineWinData>betLineWin).betLineIndex));
            }
        }
    }
}